function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Register event listeners and dispatch events.
 */
var EventDispatcher = function EventDispatcher() {
  var listeners = {};
  var queue = {};
  /**
   * Dispatch events to a certain listener type, or store them in a queue.
   */

  var dispatch = function dispatch(type, payload) {
    if (listeners[type]) {
      listeners[type].forEach(function (fn) {
        return fn(payload);
      });
    } else {
      queue[type] = [].concat(_toConsumableArray(queue[type] || []), [payload]);
    }
  };
  /**
   * Store listener with callback function per type. Invoke the queue if it exists.
   */


  var add = function add(type, fn) {
    listeners[type] = [].concat(_toConsumableArray(listeners[type] || []), [fn]);

    if (queue[type]) {
      queue[type].forEach(function (payload) {
        return dispatch(type, payload);
      });
      delete queue[type];
    }
  };

  return {
    add: add,
    dispatch: dispatch,
    listeners: listeners
  };
};

export default EventDispatcher;